<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
    fill="none"
    role="presentation"
    aria-hidden="true"
  >
    <path
      d="M4.75 2.5H2.75A.75.75 0 0 0 2 3.25v6c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75V7.25M7 2h3m0 0v3m0-3L5.5 6.5"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 10
    }
  }
}
</script>
